import { DescriptionBodyStyle } from "./style"

interface Props {
    children: React.ReactNode;
    margintop?: string;
    marginbottom?: string;
}

export const DescriptionBody: React.FC<Props> = ({ children, margintop, marginbottom }) => {
    return (
        <DescriptionBodyStyle $margintop={margintop} $marginbottom={marginbottom}>
            {children}
        </DescriptionBodyStyle>
    )
}